import Config from "../../config";
import AuthenticationManager from "../../helpers/AuthenticationManager";
import RegistrationApi from "../../api/Registration";
import UserManager from "../../helpers/UserManager";
import {Objects} from '../../helpers/Utilities'
import axios from 'axios'
import { sha256 } from 'js-sha256'

const DobObject = Objects.DobObject;
export default {
  data() {
    return {
      siteUrl: Config.siteUrl,
      isError: false,
      isSaving: false,
      terms: false,
      privacyPolicy: false,
      isTermsError: false,
      isPrivacyPolicyError: false,
      isServerValidationError: false,
      serverValidationErrorText: false,
      dobItems: DobObject,
      submitFunc: RegistrationApi.register,
      model: {
        firstname: null,
        surname: null,
        email: null,
        emailVerify: null,
        password: null,
        passwordVerify: null,
        visible: false,
        verifyVisible: false,
        dob: null,
        offerCode: null,
        terms: false,
        privacyPolicy: false,
        captcha: null,
        captchaFilled: false,
        referralId: null,
        subReferralId: null
      },
      dob: {
        day: null,
        month: null,
        year: null
      },
      prefilled: {
        firstname : false,
        surname: false,
        email: false,
        dob: false
      },
      captchaSiteKey: Config.captchaSiteKey
    }
  },
  computed: {
    isValidAge: function () {
      if (this.dob.day && this.dob.month && this.dob.year) {
        let userDob = `${this.dob.year.value}-${this.dob.month.value}-${this.dob.day}`;
        let dob = moment(userDob);
        let ageRestrict = moment().subtract(18, 'years');
        let validAge = moment(dob).isBefore(ageRestrict);
        return validAge;
      }
    },
    isOlderThan100: function() {
      if (this.dob.day && this.dob.month && this.dob.year) {
        let userDob = `${this.dob.year.value}-${this.dob.month.value}-${this.dob.day}`;
        let dob = moment(userDob);
        let ageRestrict = moment().subtract(100, 'years');
        let validAge = moment(dob).isBefore(ageRestrict);
        return validAge;
      }
    }
  },
  watch: {
    'dob.day': function () {
      let self = this;
      self.formatDateOfBirth();
      self.isServerValidationError = false;
    },
    'dob.month': function () {
      let self = this;
      self.updateValidDobMonthDays();
      self.formatDateOfBirth();
      self.isServerValidationError = false;
    },
    'dob.year': function () {
      let self = this;
      self.updateValidDobMonthDays();
      self.formatDateOfBirth();
      self.isServerValidationError = false;
    },
  },
  methods: {
    formatDateOfBirth() {
      let self = this;
      if ((!_.isNull(self.dob.day)) && (!_.isNull(self.dob.month)) && (!_.isNull(self.dob.year))) {
        self.model.dob = self.dob.year.value + '-' + self.dob.month.value + '-' + self.dob.day
      }
    },
    updateValidDobMonthDays() {
      let self = this;
      if (!self.dob.month || !self.dob.month.daysCount) {
        return;
      }

      let days = self.dob.month.daysCount + 1;

      if (!_.isNull(self.dob.year) && self.dob.year.isLeap === true && self.dob.month.value === "02") {
        days = self.dob.month.daysCount + 2;
      }

      let daysArray = [];

      for (let i = 1; i < days; i++) {
        if (i < 10) {
          daysArray.push('0' + i + '')
        } else {
          daysArray.push('' + i + '')
        }
      }

      self.$set(self.dobItems, 'days', daysArray);
    },
    setTerms() {
      let self = this;
      self.terms = !self.terms;
      self.isTermsError = false;
    },
    setPrivacyPolicy() {
      let self = this;
      self.privacyPolicy = !self.privacyPolicy
      self.isPrivacyPolicyError = false;
    },
    submitForm() {
      let self = this;
      if (self.isOlderThan100 === true) {
        self.$toastr.error("You have to be under 100 to sign up");
        return;
      }
      //Verifies User Credentials
      self.$validator.validateAll()
        .then(function (valid) {
          if (valid && self.isValidAge) {
            let fbRegModel = {
              "data": [
                {
                  "event_name": "Registered",
                  "event_time": moment().unix(),
                  "action_source": "email",
                  "user_data": {
                    "em": sha256(self.model.email),
                    "client_ip_address": self.$store.state.geoLocation.host.ip,
                    "client_user_agent": navigator.userAgent
                  },
                  "custom_data": {
                    "regModel": self.model
                  }
                }
              ]
            }
            axios.post('https://graph.facebook.com/v11.0/625160948457652/events?access_token=EAALxgEaGHOQBAPhSgGaAn8wfcfGUmKNrCk6cpoQO7NX85wxgmaD56HgMmGQLUEKMPsyCAFgMuh33vl8r1go8uO1xHgCoM3y9Ggkm2JejlIX6jeoCEW3GnA9V9N6FMInLHjSh9lzKmaEAIacBfG0o4NUqUcdolpi4frbZCh8VQU1qPtpK30wSj3VbxTKQZD', fbRegModel)
              .then((res) => {

              })
              .catch((res) => {

              })

            const clonedPassword = btoa(self.model.password);

            let registrationModel = {
              firstname: self.model.firstname,
              surname: self.model.surname,
              email: self.model.email,
              password: clonedPassword,
              dob: self.model.dob,
              offerCode: self.model.offerCode,
              captcha: self.model.captcha,
              referralId: self.model.referralId,
              subReferralId: self.model.subReferralId
            };

            let isHcp = self.$route.query.hcp;
            if (isHcp) {
              registrationModel.is_hcp = true;
            }

            if (self.model.email !== self.model.emailVerify) {
              self.$toastr.error("Emails do not match");
              return;
            }

            if (self.model.password !== self.model.passwordVerify) {
              self.$toastr.error("Please enter passwords that match");
              return;
            }

            if(self.model.terms !== true) {
              self.$toastr.error("Please agree to our terms and conditions");
              return;
            }

            if(self.model.privacyPolicy !== true) {
              self.$toastr.error("Please agree to our privacy policy");
              return;
            }

            if(self.model.captchaFilled === false) {
              self.$toastr.error("Please complete the captcha");
              return;
            }

            self.isSaving = true;
            self.submitFunc(registrationModel)
              .then(function (response) {

                self.$gtag.event({
                  'event_category': 'Registration',
                  'event_label': 'New user',
                  'event_action': 'RegistrationSuccess',
                  'event_value': 1
                });

                self.$gtag.event({
                  'event_category': 'Registration',
                  'event_label': 'Initial registration form completed',
                  'event_action': 'InitialRegistration',
                  'event_value': 1
                });

                fbq('track', 'CompleteRegistration', {content_name: 'lowcarbprogram'});

                const token = AuthenticationManager.setAccessTokenExpiryTime(response.data.token);
                AuthenticationManager.setToken(token);
                UserManager.store(self, response.data);
                UserManager.get(self);

                // redirect if user is hcp
                if (isHcp) {
                  self.$router.push({
                    name: 'HcpGettingStarted'
                  });
                } else {
                  self.$router.push({
                    name: 'Subscription'
                  });
                }
              })
              .catch(function (error) {

                  self.isSaving = false;
                  self.model.captchaFilled = false;

                  if (error.response.status === 500) {

                    self.isError = true;
                    self.$gtag.event({
                      'eventCategory': 'Registration',
                      'eventLabel': 'Error signing up',
                      'eventAction': 'RegistrationError',
                      'eventValue': 1
                    });
                  } else if (error.response.status === 422 || error.response.status === 400) {
                    self.isServerValidationError = true;
                    self.serverValidationErrorText = error.response.data.message;
                  }

                });


          } else if (!self.isValidAge) {
            self.$toastr.error("You have to be 18 or over to sign up");
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/RegistrationMixin/index.js